import MediaFile from 'models/core/mediaFile/Model.MediaFile';
import User from 'models/core/user/Model.User';
import Model from 'models/Model';

export default class ContractRefundDocument
  extends Model<Model.IContractRefundDocument>({ icon: 'fas-cloud' })
  implements Model.Instance<Model.IContractRefundDocument>
{
  id: number;
  name: string;
  notes?: string;

  contractRefundId: number;

  mediaFile: MediaFile;
  mediaFileId: number;

  createdAtUtc: string;
  modifiedAtUtc: string;

  createdBy: User;
  createdById: number;

  modifiedBy: User;
  modifiedById: number;

  formFile?: File;

  constructor(
    data: Partial<Model.IContractRefundDocument> | Utils.FormData<Model.IContractRefundDocument>,
    language?: Locale.Languages
  ) {
    super(
      {
        modifiedBy: User,
        createdBy: User,
        mediaFile: MediaFile,
      },
      language
    );
    this.update(data);
  }
  get displayInfo(): Model.DisplayInfo {
    return {
      id: this.id,
      title: this.name || this.id.toString(),
    };
  }
}
